/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import AssignProjectsForm from './AssignProjectsForm/AssignProjectsForm';
import AssignProjectsSuccess from './AssignProjectsSuccess/AssignProjectsSuccess';
import AssignProjectsError from './AssignProjectsError/AssignProjectsError';
import Form from '../../../../../forms/_.extend';

import Loading from 'components/Loading/Loading';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AssignProjects extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const costCenter: Object = this.props.costCenter;

    const fields: Array<Object> = [
      {
        name: 'assignProjects',
        label: t('general:actions.select_projects'),
        title: 'Select Project(s)',
        fields: [
          {
            name: 'projectIds',
            label: t('general:labels.assignee'),
            rules: 'required|array',
            value: [],
            placeholder: t('general:placeholders.project_code'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { projectIds }: Object = data.values().assignProjects;

        actionDrawerStore.assignProjectsToCC(costCenter.id, {
          projects: projectIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Assign Project(s)',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const costCenter: Object = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.assign_projects')} />
          <AssignProjectsError {...costCenter} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.assign_projects')} />
          <AssignProjectsSuccess {...costCenter} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.assign_projects')} />
        <AssignProjectsForm {...costCenter} form={this.createForm()} />
      </div>
    );
  }
}
